// extracted by mini-css-extract-plugin
export default {"generate":"hjTLJs1tEGNwvGgJvO2N"};